// Original source: /Users/matteo/projects/vareselab/backend/src/shared/config.ts
export class Config {
  static projectName: string = "VareseLab";
  static currency: string = "eur";
  static author: string = "Matteo Ricupero";
  static domainName: string = "vareselab.co";
  static analyticsWebsiteId: string = "";
  static apiUrl: string = "https://api.vareselab.co";
  static apiStagingUrl: string = "https://api.staging.vareselab.co";
  static apiDevUrl: string = "http://localhost:8080";
  static uneedName: string = "vareselab";
  static MORNING_SLOT = { start_time: "08:00", end_time: "14:00" };
  static AFTERNOON_SLOT = { start_time: "14:00", end_time: "20:00" };
  static MAX_SLOT_CAPACITY = 10;
  static SLOT_PER_WEEK = 2;
  static BOOKING_ALLOWED_FROM = { day: "sunday", hour: 16, minute: 0 };
  static MEMBERSHIP_FULL_MONTHLY_PRICE = 100;
  static MEMBERSHIP_DISCOUNT_MONTHLY_PRICE = 70;
  static MEMBERSHIP_CARNET_10_PRICE = 100;
  static DISCOUNT_VALID_UNTIL = "2026-01-31";
  static MEMBERSHIP_VAT = 22;
}
